import Image from "next/image";
import Link from "next/link";

const Logo: React.FC = () => {
  return (
    <Link href="/">
      <Image
        src="/images/logo/logo-transparent.png"
        alt="logo"
        width={160}
        height={50}
        // style={{ width: "auto", height: "auto" , maxWidth:'150px'}}
        quality={100}
        className="w-auto h-auto max-w-50 "
      />
    </Link>
  );
};

export default Logo;
